import type { DatePanelStepDirection } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { isMonthWithinBounds } from "web_myplann/Shared/Components/FlatRow/isMonthWithinBounds";
import { stepMonth } from "web_myplann/Shared/Components/FlatRow/stepMonth";

export const isMonthStepEnabled = (
	year: number,
	monthIndex: number,
	direction: DatePanelStepDirection,
	minDate?: Date,
	maxDate?: Date,
): boolean => {
	const target = stepMonth(year, monthIndex, direction);

	return isMonthWithinBounds(target.year, target.monthIndex, minDate, maxDate);
};
